import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { errorMessage, successMessage } from "../../../utils/alertMessage";
import { addUserRole, updateUserRole } from "../../../services/userMasterUser";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";

export default function RoleCreate() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [input, setInput] = useState({
    roleName: state?.roleName || "",
    roleCode: state?.roleCode || "",
    status: state?.status || true,
  });
  const [errors, setErrors] = useState({
    roleName: "",
    roleCode: "",
    status: "",
  });

    useEffect(() => {
      if (state) {
        setInput(prevState => ({
          ...prevState,
          status: state?.status,
        }));
      }
    }, [state]);

   

  const [statusData, setStatusData] = useState([
    { label: "ACTIVE", value: true },
    { label: "INACTIVE", value: false }
  ]);

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    // Example: Validate email format
    // const emailRegex = /^\S+@\S+\.\S+$/;
    
    if (!(input.roleName)) {
      newErrors.roleName = "Please Enter Role Name";
      isValid = false;
    } else {
      newErrors.firstName = "";
    }
    
    
 
    if (input.roleCode === "") {
      newErrors.roleCode = "Please Enter Role Code";
      isValid = false;
    } else {
      newErrors.roleCode = "";
    }

    // Add more validation logic for other fields as needed

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      if (state) {
        let data = {
          id: state?.id,
          roleName: input.roleName,
          roleCode: input.roleCode,
          status: input.status,
        };
        updateUserRole(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/role/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      } else {
        let data = {
          roleName: input.roleName,
          roleCode: input.roleCode,
        };
        addUserRole(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/user-master/role/list");
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      }
    }
  };

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <h5 className="card-title flex">
                  <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate("/user-master/role/list")}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </div> User Role {state ? "Update" : "Create"}
                </h5>
                <form onSubmit={handleSubmit}>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Role Name
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="roleName"
                        name="roleName"
                        value={input.roleName}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            roleName: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.roleName}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Role Code
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="roleCode"
                        name="roleCode"
                        value={input.roleCode}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            roleCode: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.roleCode}</div>
                    </div>
                  </div>
                  
                  {state?.id && <div className="row mb-3">
                    <div className="col-md-12">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={statusData}
                        value={input.status}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            status: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.status}</div>
                    </div>
                  </div>}
                  <div className="col-md-12 text-center">
                    <button type="submit" className="move-btn move-btn-blue">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
